import { render, staticRenderFns } from "./questIntro.vue?vue&type=template&id=c01b871c&scoped=true"
import script from "./questIntro.vue?vue&type=script&lang=js"
export * from "./questIntro.vue?vue&type=script&lang=js"
import style0 from "./questIntro.vue?vue&type=style&index=0&id=c01b871c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01b871c",
  null
  
)

export default component.exports